import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
    //header-related styles
    header: {
        "& > span": {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            wordBreak: 'break-all',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textTransform: 'uppercase',
            fontFamily: 'Lato',
            fontSize: '0.75rem',
            fontWeight: '600',
            color: '#475569',
        },
    },
    hoverHeader: {
        color: theme.colors.neutral['600'],
        cursor: 'pointer',
        "&:hover": {
            color: theme.colors.neutral['900'],
            "& > svg": {
                color: theme.colors.neutral['900'],
                stroke: `${theme.colors.neutral['900']} !important`,
            },
        },
    },
    // component-related styles
    title: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-all',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    label: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-all',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: 'Lato',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    sublabel: {
        fontWeight: '500',
        fontSize: '0.8rem',
        color: theme.colors.neutral['500'],
    },
    plainText: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-word',
        overflow: 'hidden',
        textOverflow:'ellipsis',
        fontFamily: 'Lato',
        fontSize: '0.8rem',
        fontWeight: 500,
        textDecoration: 'none',
        color: theme.colors.neutral['700'],
    },
    value: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: theme.colors.neutral['500'],
    },
    icon: {
        width: 24,
        height: 24,
    },
    icon28: {
        width: 28,
        height: 28,
    },
    checkBox: {
        padding: 'unset !important',
        marginRight: '4px !important',
        "& > svg": {
            width: '20px !important',
            height: '20px !important',
        }
    },
    url: {
        display: 'block',
        fontFamily: 'Lato',
        fontSize: '0.8rem',
        fontWeight: 500,
        textDecoration: 'none',
        color: theme.colors.neutral['700'],
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        "&:hover": {
            textDecoration: 'none !important',
        },
    },
    modal: {
      position: 'relative',
      width: 400,
      height: 400,
    },
    wave: {
        borderRadius: '4px !important',
        height: '24px !important',
    },
    activity: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: theme.colors.neutral['600'],
    },
    person: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    clear: {
        minWidth: 'unset',
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 600,
        color: theme.palette.warning.dark,
        textTransform: 'none',
        "&:hover": {
            background: 'unset',
        }
    },
    sortHeaders: {
        minWidth: 'unset',
        paddingLeft: 'unset',
        fontFamily: 'Inter',
        fontSize: '1.1rem',
        fontWeight: '600',
        color: theme.colors.neutral['600'],
        textTransform: 'none',
        "&:hover": {
            background: 'unset',
        }
    },
}));

export default useStyles;